import { CheckCircle2, AlertCircle, XCircle } from "lucide-react";

const configs = {
  good:    { icon: CheckCircle2, color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200" },
  warning: { icon: AlertCircle,  color: "text-amber-600",   bg: "bg-amber-50",   border: "border-amber-200"   },
  bad:     { icon: XCircle,      color: "text-red-600",     bg: "bg-red-50",     border: "border-red-200"     },
};

export function IndicatorItem({ label, score, value, status }) {
  const cfg = configs[status] || configs.good;
  const Icon = cfg.icon;

  return (
    <div
      className={`flex items-center justify-between p-3 rounded-xl border ${cfg.bg} ${cfg.border}`}
      data-testid={`indicator-${label}`}
    >
      <div className="flex items-center gap-3">
        <Icon className={`w-5 h-5 ${cfg.color}`} />
        <div>
          <p className="text-sm font-semibold text-gray-800">{label}</p>
          <p className="text-xs text-gray-500">{value}</p>
        </div>
      </div>
      <span className={`text-lg font-bold ${cfg.color}`}>{score}</span>
    </div>
  );
}
